import React from "react";

export default function CARTile({ eyebrow, title, body, footnote }) {
  return (
    <div
      className="flex flex-col gap-3 p-7 border border-slate-200 bg-white h-full"
      data-testid={`car-tile-${eyebrow.toLowerCase()}`}
    >
      <span className="eyebrow">{eyebrow}</span>
      <h3 className="font-display text-2xl text-[var(--ink-heading)] leading-snug">
        {title}
      </h3>
      <p className="text-[var(--ink-secondary)] leading-relaxed">{body}</p>
      {footnote && (
        <p className="text-xs text-[var(--ink-muted)] mt-2 font-mono-ui">{footnote}</p>
      )}
    </div>
  );
}
